export default __webpack_public_path__ + "static/media/explore.84d9ba79.png";